import styled from 'styled-components';

import { DischargeFormMeta, DischargeFormValues } from 'components/dischargeForm/DischargeInformation';
import FileInputComponent from 'components/shared/fileInput/FileInputComponent';
import { useForm } from 'context/form';
import { useTranslation } from 'context/translations';
import Upload from 'hooks/useDirectUpload/Upload';
import { DocumentTypes } from 'models/Attachment';
import { BodySmall } from 'styles/typography';
import TagIcon from 'svg/TagIcon';

export default function DischargeFileRequests() {
  const { values, setValue, setMeta } = useForm<DischargeFormValues, DischargeFormMeta>();
  const { translate } = useTranslation();

  return (
    <Container>
      <BodySmall>
        Attach the patient's {translate('discharge').toLowerCase()} summary below or click&nbsp;&nbsp;
        <StyledTagIcon width={14} height={16} />
        &nbsp;&nbsp;to mark an attached file as "{translate('Discharge')} Summary"
      </BodySmall>
      <FileInputComponent
        initialUploads={values.note?.attachments || []}
        onChange={(uploads: Upload[]) => setValue('note', { ...values.note, attachments: uploads })}
        onUploading={(uploading) => setMeta('isUploadingAttachments', uploading)}
        renderUploadsInternally={false}
        defaultDocType={DocumentTypes.DischargeSummary}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledTagIcon = styled(TagIcon)`
  margin-bottom: -2px;
`;
